
<script>
import ActivitySummary from "../ActivitySummary";
import informationDigestService from "../../common/InformationDigestService";

export default {
  name: "FundraisingPageSummary",
  mixins: [ActivitySummary],

  methods: {
    async fetchFromServices() {     
      return await informationDigestService.getFundraisingPageDigestSummary(
        this.fundraisingPageId
      );
    }
  }
};
</script>
<style scoped></style>
